export * from './src/receipts-presets-v1-receipt-preset-receipt-presets.meta.js';
